<template>
    <AppHead :title="'All episodes (' + episodes.total + ')'" />

    <section class="mb-8 md:pb-12 pt-6 md:pt-0 px-4">
        <SectionHeading :title="'All episodes (' + episodes.total + ')'" importance="1" class="px-4 xl:px-0"/>
        <div class="flex flex-col space-y-4 md:space-y-6 mb-12">
            <EpisodeItem v-for="episode in episodes.data" :episode="episode" :podcast="episode.podcast" />
        </div>
        <div class="">
            <div v-if="episodes.links.length > 3" class="w-full flex justify-between items-center text-sm font-medium">
                <div class="text-gray-800 font-normal">
                    Showing <span class="font-bold">{{ episodes.from }}</span> to <span class="font-bold">{{ episodes.to }}</span> of <span class="font-bold">{{ episodes.total }}</span> episodes
                </div>
                <div class="">
                    <div class="grid grid-flow-col divide-x divide-gray-400 border border-gray-400 rounded">
                        <div v-for="(link, index) in episodes.links">
                            <Link v-if="index === 0 && episodes.prev_page_url" class="px-2 h-10 text-gray-800 flex items-center justify-center rounded-l  hover:bg-gray-400" :href="episodes.prev_page_url" :only="['episodes']">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
                            </Link>
                            <div v-if="index === 0 && !episodes.prev_page_url" class="text-gray-500 cursor-no-drop px-2 h-10 flex items-center justify-center rounded-l ">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
                            </div>
                            <Link v-if="index !== 0 && index !== episodes.links.length - 1" class="px-4 h-10 flex items-center justify-center" :href="link.url" :only="['episodes']" :class="{ 'bg-regal-blue-100 text-regal-blue-700': link.active, 'text-gray-800 hover:bg-gray-300': !link.active}">
                                {{ link.label }}
                            </Link>
                            <Link v-if="index === episodes.links.length - 1 && episodes.next_page_url" class="px-2 h-10 text-gray-800 flex items-center justify-center rounded-r  hover:bg-gray-400" :href="episodes.next_page_url" :only="['episodes']">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
                            </Link>
                            <div v-if="index === episodes.links.length - 1 && !episodes.next_page_url" class="text-gray-500 cursor-no-drop px-2 h-10 flex items-center justify-center rounded-r " :href="episodes.next_page_url" :only="['episodes']">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Layout from '@/Shared/Layout'
    import SectionHeading from '@/Shared/SectionHeading'
    import EpisodeItem from '@/Shared/EpisodeItem'

    export default {
        props: {
            episodes: Object,
        },
        components: { SectionHeading, EpisodeItem },
        layout: Layout,
    }
</script>
